import './container.scss';
import Raven from 'raven-js';

export const ContainerComponent = {
    template: `
        <div class="container-wrapper" ng-style="{'background-image': 'url(' + $ctrl.data.restaurantInfo.imageSet.background.url + ')'}">
            <div class="show-sm mobile-banner">
                <h1>{{$ctrl.data.name}}</h1>
            </div>
            <div class="modal flex-row">
                <div class="column column-sm-4 hide-sm modal-left">
                    <img class="thumbnail" ng-src="{{$ctrl.data.restaurantInfo.imageSet.thumbnailLarge.url}}" />

                    <h5>{{$ctrl.data.name}}</h5>
                </div>

                <div class="column column-sm-8 modal-right">
                    <h1>Online Ordering</h1>
                    <dining-option></dining-option>

                    <location-picker></location-picker>

                    <restaurant-list></restaurant-list>

                    <p class="error-message" ng-if="!$ctrl.data.diningOptions.hasDelivery && !$ctrl.data.diningOptions.hasTakeout">
                        Online ordering is currently disabled
                    </p>
                </div>
            </div>
        </div>
    `,
    controller: function(googleAnalyticsService, restaurantService) {
        'ngInject';
        const ctrl = this;
        ctrl.data = restaurantService.data;

        googleAnalyticsService.trackPageViewEvent('/');
    }
};
